import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44f671e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body-modal" }
const _hoisted_2 = {
  key: 0,
  class: "step-header"
}
const _hoisted_3 = { class: "marked" }
const _hoisted_4 = {
  key: 1,
  class: "action-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "floating-card-component",
    class: _normalizeClass(["body-modal-container", {
      'next-on-animation': _ctx.nextShowAnimation,
      'next-out-animation': _ctx.nextDismissAnimation,
      'previous-on-animation': _ctx.previousShowAnimation,
      'previous-out-animation': _ctx.previousDismissAnimation,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.onlyCard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, "Passo " + _toDisplayString(_ctx.stepNumber) + " - ", 1),
            _createTextVNode(_toDisplayString(_ctx.stepTitle), 1)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "content", {}, undefined, true),
      (!_ctx.onlyCard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-default btn-primary", { 'btn-disabled': !_ctx.nextButtonActive }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('nextStep')))
            }, _toDisplayString(_ctx.btnNextLabel), 3),
            _createElementVNode("button", {
              class: "btn btn-default btn-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$emit('previousStep')))
            }, " Voltar ")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}